<ng-container *transloco="let t; read: 'comparison-filter-item.dynamic-date-item'">
  <div class="dynamic-date-item__container">
    <xi-input-field
      [ngModel]="rangeNumber"
      [disabled]="!isEnabled"
      [readOnly]="isReadOnly"
      type="number"
      [min]="rangeNumberMin"
      [max]="rangeNumberMax"
      appOnlyDigit
      (onChange)="onRangeValueChanged($event.detail.target.value)"
    ></xi-input-field>
    <xi-dropdown
      [ngModel]="rangeType"
      [data]="rangeTypes"
      [disabled]="!isEnabled"
      [readOnly]="isReadOnly"
      (onValueChange)="onRangeTypeChanged($event.detail.selected.id)"
    ></xi-dropdown>
    <span>{{ t('prior-to-selected-range') }}</span>
  </div>
  @if (isOutOfBound) {
    <p class="error-message name-error">
      <xi-icon icon="warning_filled" iconSize="small" color="error"></xi-icon>
      {{ t('range-error-message', { min: rangeNumberMin, max: rangeNumberMax }) }}
    </p>
  }
  <div>
    <div class="dynamic-date-item__selected-range">
      {{ dynamicStartDate | date }} - {{ dynamicEndDate | date }}
    </div>
  </div>
</ng-container>
